import GlobalStyles from './styles/GlobalStyles';
import createTheme from './styles/theme';
import { CURRENCIES, CURRENCY_SYMBOL } from 'common-ui/src/utils/constants';
import { commonInitApp } from 'common-embedded';

const brandObject = {
   country: 'au',
    brandId: 'vws',
    currencyCode: CURRENCIES.AUD,
    currency: CURRENCY_SYMBOL.AUD,
    // Points / Redemption
    pointsLabel: 'Points',
    locale: 'en-AU',
};

const initApp = commonInitApp({ brandObject, createTheme, GlobalStyles });

export default initApp;